import $ from 'jquery';

class CreateGroup {
	constructor(){
		// Check if the page has the [uo_groups_create_group] 
		// shortcode, or the respective Gutenberg block
		if ( this.isCreateGroup() ){
			// Get elements
			this.getElements();

			// Add multi-select pillbox to the
			// "Group Courses" field
			this.addPillboxToGroupCourses();
		}
	}

	getElements(){
		this.$elements = {
			coursesList: $( '#ulg-create-group__courses-list' )
		}
	}

	/**
	 * Add multi-select pillbox to the
	 * "Group Courses" field
	 */
	addPillboxToGroupCourses(){
		this.$elements.coursesList.select2({
			theme: 'default ulg-select2'
		});
	}

	/**
	 * Check if the page has the [uo_groups_create_group] 
	 * shortcode, or the respective Gutenberg block
	 */
	isCreateGroup(){
		return $( '#ulg-create-group' ).length == 1;
	}
}

export default CreateGroup;